import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { ChangeEvent, FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IItemsConsulta from 'Infotrack@Modelos/smartStock/items/entidades/IItemsConsulta';

import useStyles from './campoItemCodigoBarrasEstilos';

interface ICampoItemCodigoBarrasProps {
    deshabilitado: boolean;
    items: IItemsConsulta[];
    manejarCambio: (nuevoValor: IItemsConsulta | null) => void;
    valor: IItemsConsulta | null;
}

const CampoItemCodigoBarras: FunctionComponent<ICampoItemCodigoBarrasProps> = ({
    deshabilitado,
    items,
    manejarCambio,
    valor,
}) => {
    const classes = useStyles();

    return (
        <Autocomplete
            classes={{ root: classes.campoItemCodigoBarras }}
            disabled={deshabilitado}
            onChange={(_: ChangeEvent<{}>, value: IItemsConsulta | null) => manejarCambio(value)}
            options={items}
            getOptionLabel={(i) => i.CodigoEmpresa? i.CodigoEmpresa:""}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    label={<Texto id="DetallesInventario.CampoItemCodigoEmpresa" />}
                />
            )}
            value={valor}
            id={'CampoItemCodigoEmpresa'}
        />
    );
};

export default CampoItemCodigoBarras;
